export const version = 'berater-v1.15.0-SNAPSHOT-2815bdec43318ae4a3e90f8284d3421ac45d3d17';